<!-- Annotation Link Form -->
@if (annotationLinkForm) {
  <medsurf-design-form-control-form
    [formGroup]="annotationLinkForm"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column field">
      <label class="flex flex-grow-1">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ 'global.linking' | translate }}
        </span>
      </label>
      <div medsurf-design-content-input-group>
        <!-- Type -->
        <medsurf-design-form-control-input-dropdown [control]="annotationLinkForm.controls.type"
          [options]="FlatModels.LinkEntityModels.LinkTypeArray"
        [dropdownClass]="'medsurf-dropdown'"></medsurf-design-form-control-input-dropdown>
        <!-- Link -->
        @if (annotationLinkForm.value.type) {
          @if (annotationLinkForm.value.type === FlatModels.LinkEntityModels.LinkType.enum.Slide) {
            <medsurf-design-form-control-input-number
              [control]="annotationLinkForm.controls.link"
              [class]="'w-full'"
            (valueChange)="onSubmit()"></medsurf-design-form-control-input-number>
          }
          @if (annotationLinkForm.value.type === FlatModels.LinkEntityModels.LinkType.enum.Site) {
            <medsurf-design-form-control-input-text
              [control]="annotationLinkForm.controls.link"
              [class]="'w-full'"
            (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
          }
        }
      </div>
    </div>
  </medsurf-design-form-control-form>
}